import React, {useEffect} from 'react';
import {Affix, Button} from "antd";
import {CloseCircleFilled, CloseOutlined, MailOutlined} from "@ant-design/icons";
import {useProject} from "../../providers/ClientProjectProvider";
import {useLocation, useParams, useSearchParams} from "react-router-dom";
import {useAuth} from "../../providers/AuthProvider";
import {useIsFetching} from "@tanstack/react-query";
import BulkCandidatesContactForm from "./BulkCandidatesContactForm";

const BulkActionsContainer = (props) => {
    const {project, isLoading, requestSOW, bulkActions, onClearBulkActions, onRunBulkActions} = useProject();
    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();

    const {positionId} = useParams();
    const {auth} = useAuth();

    const isFetchingTalent = useIsFetching(['positionMatches']);

    useEffect(() => {
        if (bulkActions?.length) {
            onClearBulkActions();
        }
    }, [positionId]);

    const sendMessageToCandidates = async () => {
        if (!project.posts_on_talent_job_board) {
            return TB.alert(
                "warning", "Bulk Messaging Disabled",
                'Bulk messaging is disabled because this project is not visible on the talent Job Board. ' +
                'To send messages, update the "Posts on Job Board?" project setting.', [{title: "Ok"}]
            );
        }

        let params = new URLSearchParams(searchParams);

        params.set("send-candidate-message", "1");
        await setSearchParams(params);
    }

    if (!auth?.canManageClients()) {
        return null;
    }

    return (
        <React.Fragment>
            <Affix offsetBottom={90} style={{
            position: "absolute",
            left: 0,
            bottom: 0,
            right: 0,
            zIndex: 100,
            pointerEvents: bulkActions.length > 0 ? 'auto' : 'none'
        }}>
            <div className={TB.mapClass("bulk-actions-container", {
                isVisible: bulkActions.length > 0
            })}>
                <p className="font-light text-xs mr-auto">
                    ({bulkActions.length} selected)
                </p>

                <Button type="text" onClick={async () => {
                    let confirm = await TB.alert("warning",
                        "Archive Candidates",
                        `Are you sure you want to archive the selected ${bulkActions?.length} candidates?`, [
                            {title: 'Yes, Continue'},
                            {title: 'Cancel'},
                        ])
                    if (confirm) {
                        let response = await onRunBulkActions("archive", positionId)
                    }
                }}>
                    <p className="flex flex-row items-center gap-1.5">
                        <CloseCircleFilled style={{fontSize: 18}}/>
                        <span className="capitalize font-medium text-sm mt-[2px]">ARCHIVE</span>
                    </p>
                </Button>

                <Button type="text" onClick={() => sendMessageToCandidates()}>
                    <p className="flex flex-row items-center gap-1.5">
                        <MailOutlined style={{fontSize: 18}}/>
                        <span className="capitalize font-medium text-sm mt-[2px]">MESSAGE</span>
                    </p>
                </Button>


                <CloseOutlined onClick={() => onClearBulkActions()} className="ml-auto"/>

            </div>

        </Affix>
            <BulkCandidatesContactForm/>
        </React.Fragment>

    )
};

export default BulkActionsContainer;